module.exports = __webpack_public_path__ + "static/media/our_products_tmp.4a36d39d.jpeg";